import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const SettingsIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M17.3 9.2l1.1-2.1L17 5.7l-2.1 1.1a3.582 3.582 0 00-1.1-.4L13 4h-2l-.8 2.3a4.179 4.179 0 00-1 .4L7.1 5.6 5.6 7.1l1.1 2.1a4.179 4.179 0 00-.4 1L4 11v2l2.3.8c.1.4.3.7.4 1.1L5.6 17 7 18.4l2.1-1.1a3.582 3.582 0 001.1.4L11 20h2l.8-2.3c.4-.1.7-.3 1.1-.4l2.1 1.1 1.4-1.4-1.1-2.1a3.582 3.582 0 00.4-1.1L20 13v-2l-2.3-.8a4.179 4.179 0 00-.4-1zM12 15a2.946 2.946 0 01-3-3 2.946 2.946 0 013-3 2.946 2.946 0 013 3 2.946 2.946 0 01-3 3z" />
  </SvgIcon>
);
SettingsIcon.displayName = 'SettingsIcon';
SettingsIcon.muiName = 'SvgIcon';

export default SettingsIcon;
